import { registerComponent } from "react_mount"

registerComponent("profile-newsletters-page", () => import("containers/ProfileNewslettersIndex"))
registerComponent("profile-actions", () => import("components/Profile/Actions"))
registerComponent("profile-tabs", () => import("components/Profile/Tabs"))
registerComponent("profile-contact-details", () => import("components/Profile/ContactDetails"))
